import * as ActionTypes from '../../constants/actionType';

export const setCurrentWizardView = (currentWizardView) => ({
  type: ActionTypes.SET_CURRENT_WIZARD_VIEW,
  currentWizardView,
});

export const incrementCurrentWizardView = () => ({
  type: ActionTypes.INCREMENT_CURRENT_WIZARD_VIEW,
});

export const decrementCurrentWizardView = () => ({
  type: ActionTypes.DECREMENT_CURRENT_WIZARD_VIEW,
});

export const setCsvFileName = (csvFileName) => ({
  type: ActionTypes.SET_CSV_FILE_NAME,
  csvFileName,
});

export const setAllowedToNext = (allowedToNext) => ({
  type: ActionTypes.SET_ALLOWED_TO_NEXT,
  allowedToNext,
});

export const setCsvRawData = (csvRawData) => ({
  type: ActionTypes.SET_CSV_RAW_DATA,
  csvRawData,
});

export const setCsvData = (csvData) => ({
  type: ActionTypes.SET_CSV_DATA,
  csvData,
});

export const setCsvTotalRow = (totalRow) => ({
  type: ActionTypes.SET_CSV_TOTAL_ROW,
  totalRow,
});

export const setCsvDelimiter = (delimiter) => ({
  type: ActionTypes.SET_CSV_DELIMITER,
  delimiter,
});

export const setCsvStartRow = (startRow) => ({
  type: ActionTypes.SET_CSV_START_ROW,
  startRow,
});

export const setCsvColumnInFirstRow = (isColumnInFirstRow) => ({
  type: ActionTypes.SET_CSV_COLUMN_IN_FIRST_ROW,
  isColumnInFirstRow,
});

export const setWellIncrementPattern = (wellIncrementPattern) => ({
  type: ActionTypes.SET_WELL_INCREMENT_PATTERN,
  wellIncrementPattern,
});

export const setNormalizationSelectedLabware = (selectedLabware) => ({
  type: ActionTypes.SET_NORMALIZATION_SELECTED_LABWARE,
  sampleLabwareID: selectedLabware?.LabwareID ?? '',
});

export const setSelectedColumnIndex = (selectedColumnIndex) => ({
  type: ActionTypes.SET_SELECTED_COLUMN_INDEX,
  selectedColumnIndex,
});

export const setTargetConcentration = (targetConcentration) => ({
  type: ActionTypes.SET_TARGET_CONCENTRATION,
  targetConcentration,
});

export const setLowestConcentration = (lowestConcentration) => ({
  type: ActionTypes.SET_LOWEST_CONCENTRATION,
  lowestConcentration,
});

export const setNormalizationCurrentVolume = (currentVolume) => ({
  type: ActionTypes.SET_NORMALIZATION_CURRENT_VOLUME,
  currentVolume,
});

export const setReagentName = (reagentName) => ({
  type: ActionTypes.SET_REAGENT_NAME,
  reagentName,
});

export const setDiluentName = (diluentName) => ({
  type: ActionTypes.SET_DILUENT_NAME,
  diluentName,
});

export const setDiluentLabwareID = (selectedDiluentLabwareID) => ({
  type: ActionTypes.SET_DILUENT_LABWARE_ID,
  selectedDiluentLabwareID,
});

export const setDiluentWell = (wellParam) => ({
  type: ActionTypes.SET_DILUENT_WELL,
  wellParam,
});

export const setPreviewData = (previewData) => ({
  type: ActionTypes.SET_PREVIEW_DATA,
  previewData,
});

export const restoreNormalizationState = (state) => ({
  type: ActionTypes.RESTORE_NORMALIZATION_STATE,
  state,
});

export const resetNormalizationState = () => ({
  type: ActionTypes.RESET_NORMALIZATION_STATE,
});

export const resetNormalizationCurrentVolume = () => ({
  type: ActionTypes.RESET_NORMALIZATION_CURRENT_VOLUME,
});

export const setDefaultTargetConcentration = (data) => ({
  type: ActionTypes.SET_DEFAULT_TARGET_CONCENTRATION,
  data,
});

export const resetDefaultCurrentVolume = () => ({
  type: ActionTypes.RESET_DEFAULT_CURRENT_VOLUME,
});

export const setNormalizationType = (data) => ({
  type: ActionTypes.SET_NORMALIZATION_TYPE,
  data,
});

export const setNormalizationDiluentLabware = (diluentLabwareID) => ({
  type: ActionTypes.SET_NORMALIZATION_DILUENT_LABWARE,
  diluentLabwareID,
});
